export default "__VITE_ASSET__wMZIZcS9__"